// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ChevronDown as RawChevronDown } from "lucide-react";
export const ChevronDown = /* @__PURE__ */ createIcon(RawChevronDown, "ChevronDown", 2);
